import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-primary",
			cx: 11.3,
			cy: 17.1,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-primary",
			cx: 22.9,
			cy: 24.7,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-primary",
			cx: 32.3,
			cy: 24.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-primary",
			cx: 34.8,
			cy: 18.1,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-primary",
			cx: 36.2,
			cy: 34.4,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-primary",
			cx: 9.1,
			cy: 27.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
			x: 21.2,
			y: -5.3,
			transform: "rotate(-73.937 22.498 15.94)",
			className: "icon-fill-secondary",
			width: 2.5,
			height: 42.5
		}), /* @__PURE__ */ _jsx("rect", {
			x: 21.3,
			y: 7.8,
			transform: "rotate(-73.936 22.5 29.062)",
			className: "icon-fill-secondary",
			width: 2.5,
			height: 42.5
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M42 2.5c.3 0 .5.2.5.5v39c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h39M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
		})
	]
});
export default SvgIcon;
